export default __webpack_public_path__ + "static/media/oscer-pres-hot-flushes.60df7761.svg";